import { useAppContext } from '@contexts/app';
import { TenantCustomSetting } from '@root/globalTypes';
import { isCustomSettingEnabled } from '@utils/customSettings';

export const useCustomSettingFlag = (name: TenantCustomSetting['name']) => {
  const { tenant } = useAppContext();
  return isCustomSettingEnabled(tenant, name);
};
